import InputStateContext, { InputState } from ".";

interface Props {
    inputState: InputState;
    children: React.ReactNode;
}

const InputStateProvider = ({ inputState, children }: Props) => (
    <InputStateContext.Provider value={inputState}>
        {children}
    </InputStateContext.Provider>
);

export default InputStateProvider;
